import { render, staticRenderFns } from "./LandingPageLayout.vue?vue&type=template&id=4e0ef409&scoped=true&"
import script from "./LandingPageLayout.vue?vue&type=script&lang=ts&"
export * from "./LandingPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPageLayout.vue?vue&type=style&index=0&id=4e0ef409&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0ef409",
  null
  
)

export default component.exports